module.exports = __webpack_public_path__ + "static/img/cooperator.00278b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wolves/cooperator.png
// module id = BYgh
// module chunks = 1